module.exports = __webpack_public_path__ + "static/media/presion-03.c8afebaa.jpg";